import spacetime from "spacetime";

export default {
    install(Vue, options) {
        Vue.mixin({
            data: () => ({
            }),
            methods: {
                isPromise(obj) {
                    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
                },

                logError(e) {
                    const failure = [
                        'background: red',
                        'color: white',
                        'display: block',
                        'text-align: center'
                    ].join(';');

                    if (Array.isArray(e)) {
                        e.forEach(item => {
                            console.log(`%c ${item.key} - ${item.message}`, failure)
                        })

                    } else {
                        console.log(`%c ${e.message}`, failure)
                    }

                },
                fixTimeZone(dateUtc) {
                    let localDate = new Date();
                    let localDateTimezone = spacetime(localDate).timezone().name;
                    let s = spacetime(dateUtc)
                    if (s.year() < 1000) {
                        return "-"
                    }
                    return s.goto(localDateTimezone).format("dd.MM.yyyy HH:mm:SS")
                },

                fixTimeTest(el){
                    return spacetime(el).format('dd/MM/yyyy | HH:mm:SS');
                }

            }
        });
    }
};


// WEBPACK FOOTER //
// ./src/utils/stratum_utils/index.js